// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";

// // Pages
// import "bootstrap-icons/font/bootstrap-icons.css";
// // ✅ Import all pages
// import Homepage from "./pages/homepage/homepage";
// import Login from "./pages/login/login";
// import Signup from "./pages/signup/signup";
// import Afterlogin from "./pages/afterlogin/afterlogin";
// import Whoweare from "./pages/whoweare/whoweare";
// import Ourmission from "./pages/ourmission/ourmission";
// import Aboutus from "./pages/aboutus/aboutus";
// import Brandethos from "./pages/brandethos/brandethos";
// import Contactus from "./pages/contactus/contactus";
// import Wishlist from "./pages/wishlist/wishlist";
// import Ownbox from "./pages/ownbox/Ownbox";
// import BoxStyles from "./pages/box-styles/box-styles";
// import Boxproduct from "./pages/boxproduct/boxproduct";
// import Boxcheckout from "./pages/boxcheckout/boxcheckout";
// import Checkout from "./pages/chekckout/checkout";
// import Chocoblock from "./pages/chocoblock/chocoblock";
// import Productgrid from "./pages/product-grid/productgrid";
// import Productdetails from "./pages/productdetails/productdetails";
// import Sweetindulgence from "./pages/sweetindulgence/sweetindulgence";
// import Boxcollection from "./pages/boxcollection/boxcollection";
// import Orderconfrimed from "./pages/orderconfrimed/orderconfrimed";
// import Forgotpassword from "./pages/forgotpassword/forgotpassword";
// import Otppage from "./pages/otppage/otppage";
// import Otpvarification from "./pages/otpvarification/otpvarification";
// import Collection from "./components/collection/collection";
// import Cart from "./components/Cart/Cart";
// import Termsandcondition from "./pages/termsandcondition/termsandcondition";
// import Privacypolicy from "./pages/privacypolicy/privacypolicy";
// import Refundandcancellation from "./pages/refund&cancellationpolicy/refundandcancellation";
// import Gallery from "./pages/gallery/gallery";
// import Order from "./pages/orders/order";
// import Shiping from "./pages/shiping/shiping";
// import Faqs from "./pages/faqs/faqs";

// // -------- Protected Route Component --------
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem("token");
//   if (!token) return <Navigate to="/login" replace />;
//   return children;
// };


// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Router basename="/">
//     <Routes>
//       {/* Public Routes */}
//       <Route path="/" element={<Homepage />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/whoweare" element={<Whoweare />} />
//       <Route path="/ourmission" element={<Ourmission />} />
//       <Route path="/aboutus" element={<Aboutus />} />
//       <Route path="/brandethos" element={<Brandethos />} />
//       <Route path="/contactus" element={<Contactus />} />
//       <Route path="/forgotpassword" element={<Forgotpassword />} />
//       <Route path="/otppage" element={<Otppage />} />
//       <Route path="/otpvarification" element={<Otpvarification />} />
//       <Route path="/collection" element={<Collection />} />
//       <Route path="/terms-and-condition" element={<Termsandcondition />} />
//       <Route path="/privacy-policy" element={<Privacypolicy />} />
//       <Route path="/refund-and-cancellation" element={<Refundandcancellation />} />
//       <Route path="/gallery" element={<Gallery />} />

//       {/* Protected Routes */}
//       <Route path="/afterlogin" element={<ProtectedRoute><Afterlogin /></ProtectedRoute>} />
//       <Route path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
//       <Route path="/ownbox/:collectionId" element={<ProtectedRoute><Ownbox /></ProtectedRoute>} />
//       <Route path="/ownbox" element={<ProtectedRoute><Ownbox /></ProtectedRoute>} />
//       <Route path="/box-styles/:collectionId/:size" element={<ProtectedRoute><BoxStyles /></ProtectedRoute>} />
//       <Route path="/boxcheckout" element={<ProtectedRoute><Boxcheckout /></ProtectedRoute>} />
//       <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
//       <Route path="/boxproduct/:categoryId/:boxId" element={<ProtectedRoute><Boxproduct /></ProtectedRoute>} />

//       <Route path="/orders" element={<ProtectedRoute><Order /></ProtectedRoute>} />

//       {/* Product Routes */}
//       <Route path="/chocolateblock" element={<Chocoblock />} />
//       <Route path="/product" element={<Productgrid />} />
//       <Route path="/productdetails" element={<Productdetails />} />
//       <Route path="/product/:id" element={<Productdetails />} />
//       <Route path="/products/:category" element={<Productgrid />} />
//       <Route path="/collection/:category" element={<Productgrid />} />
//       <Route path="/sweetindulgence" element={<Sweetindulgence />} />
//       <Route path="/boxcollection" element={<Boxcollection />} />
//       <Route path="/orderconfrimed" element={<Orderconfrimed />} />
//       <Route path="/shiping" element={<Shiping />} />
//       <Route path="/cart" element={<Cart />} />
//       {/* Fallback */}
//       <Route path="/collection" element={<Collection />} />
//       <Route path="/boxproduct/:categoryId/:boxId" element={<Boxproduct />} />
//       <Route path="/cart" element={<Cart />} />
//       <Route path="/terms-and-condition" element={<Termsandcondition />} />
//       <Route path="/privacy-policy" element={<Privacypolicy />} />
//       <Route
//         path="/refund-and-cancellation"
//         element={<Refundandcancellation />}
//       />
//       <Route path="/shiping" element={<Shiping />} />
//       <Route path="/gallery" element={<Gallery />} />
//       <Route path="/orders" element={<Order />} />
//       <Route path="/ownbox" element={<Ownbox />} />
//       <Route path="/faqs" element={<Faqs />} />
//       <Route path="*" element={<h1>404 Not Found</h1>} />
//     </Routes>
//   </Router>
// );

// reportWebVitals();
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Pages
import Homepage from "./pages/homepage/homepage";
import Login from "./pages/login/login";
import Signup from "./pages/signup/signup";
import Afterlogin from "./pages/afterlogin/afterlogin";
import Whoweare from "./pages/whoweare/whoweare";
import Ourmission from "./pages/ourmission/ourmission";
import Aboutus from "./pages/aboutus/aboutus";
import Brandethos from "./pages/brandethos/brandethos";
import Contactus from "./pages/contactus/contactus";
import Wishlist from "./pages/wishlist/wishlist";
import Ownbox from "./pages/ownbox/Ownbox";
import BoxStyles from "./pages/box-styles/box-styles";
import Boxproduct from "./pages/boxproduct/boxproduct";
import Boxcheckout from "./pages/boxcheckout/boxcheckout";
import Checkout from "./pages/chekckout/checkout";
import Chocoblock from "./pages/chocoblock/chocoblock";
import Productgrid from "./pages/product-grid/productgrid";
import Productdetails from "./pages/productdetails/productdetails";
import Sweetindulgence from "./pages/sweetindulgence/sweetindulgence";
import Boxcollection from "./pages/boxcollection/boxcollection";
import OrderConfirmed from "./pages/orderconfrimed/orderconfrimed";
import Forgotpassword from "./pages/forgotpassword/forgotpassword";
import Otppage from "./pages/otppage/otppage";
import Otpvarification from "./pages/otpvarification/otpvarification";
import Collection from "./components/collection/collection";
import Cart from "./components/Cart/Cart";
import Termsandcondition from "./pages/termsandcondition/termsandcondition";
import Privacypolicy from "./pages/privacypolicy/privacypolicy";
import Refundandcancellation from "./pages/refund&cancellationpolicy/refundandcancellation";
import Gallery from "./pages/gallery/gallery";
import Order from "./pages/orders/order";
import Shiping from "./pages/shiping/shiping";
import Faqs from "./pages/faqs/faqs";

// Google OAuth
import { GoogleOAuthProvider } from "@react-oauth/google";
const GOOGLE_CLIENT_ID = "474626325704-sgbhbqd6raba0hro7kea8gmjo44tst3j.apps.googleusercontent.com";

// -------- Protected Route Component --------
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router basename="/">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/whoweare" element={<Whoweare />} />
          <Route path="/ourmission" element={<Ourmission />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/brandethos" element={<Brandethos />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/otppage" element={<Otppage />} />
          <Route path="/otpvarification" element={<Otpvarification />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/terms-and-condition" element={<Termsandcondition />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/refund-and-cancellation" element={<Refundandcancellation />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/chocolateblock" element={<Chocoblock />} />
          <Route path="/product" element={<Productgrid />} />
          <Route path="/productdetails" element={<Productdetails />} />
          <Route path="/product/:id" element={<Productdetails />} />
          <Route path="/products/:category" element={<Productgrid />} />
          <Route path="/collection/:category" element={<Productgrid />} />
          <Route path="/sweetindulgence" element={<Sweetindulgence />} />
          <Route path="/boxcollection" element={<Boxcollection />} />
          <Route path="/order-confirmed" element={<OrderConfirmed />} />
          <Route path="/shiping" element={<Shiping />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/faqs" element={<Faqs />} />

          {/* Protected Routes */}
          <Route path="/afterlogin" element={<Afterlogin />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/ownbox/:collectionId" element={<Ownbox />} />
          <Route path="/ownbox" element={<Ownbox />} />
          <Route path="/box-styles/:collectionId/:size" element={<BoxStyles />} />
          <Route path="/boxcheckout" element={<Boxcheckout />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/boxproduct/:categoryId/:boxId" element={<Boxproduct />} />
          <Route path="/orders" element={<Order />} />

          {/* Fallback */}
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
